import useAppMutation from 'hooks/useAppMutation';
import {
  CreatePromoCodePayload,
  CreatePromoCodeResponse,
} from 'models/PromoCode';
import API from 'services/API';

const useCreatePromoCode = () => {
  const { mutateAsync: createPromoCode, isLoading } = useAppMutation(
    (payload: CreatePromoCodePayload) =>
      API.post<CreatePromoCodeResponse>('/api/v3.2/promo-codes', payload),
  );

  return { createPromoCode, isLoading };
};

export default useCreatePromoCode;
